/**
 * Converts the `forecast.months` / `history.months` plan limits (always
 * expressed in months) into a period count for a given period type.
 *
 * Mirrors the backend's App\Services\Subscriptions\HorizonLimits exactly at
 * every option the horizon picker actually offers (3mo=13wk, 6mo=26wk,
 * 12mo=52wk) — keep the two in sync if either changes.
 */
export function maxHorizonPeriods(
  periodType: 'Week' | 'Month',
  limitMonths: number,
): number {
  if (!Number.isFinite(limitMonths)) return Infinity
  return periodType === 'Week'
    ? Math.floor((limitMonths * 13) / 3)
    : limitMonths
}
